import moment from "moment";

/**
 * Formats a date string into the "YYYY-MM-DD HH:mm:ss" format.
 * The input string can be in one of the following formats:
 * - "MMMM Do, YYYY" (e.g., "April 17th, 2024")
 * - "YYYY-MM-DD HH:mm:ss" (e.g., "2024-04-17 12:34:56")
 *
 * @param date_string - The date string to format. If undefined, an error will be thrown.
 * @returns The formatted date string in "YYYY-MM-DD HH:mm:ss" format.
 * @throws Throws an error if the input is undefined or does not match one of the expected formats.
 */
export function formatDate(date_string: string | undefined): string {
  if (!date_string) {
    throw new Error("Input is undefined");
  }

  let date;

  // Check if the input matches the format "MMMM Do, YYYY"
  if (moment(date_string, "MMMM Do, YYYY", true).isValid()) {
    date = moment(date_string, "MMMM Do, YYYY");
  }
  // Check if the input matches the format "YYYY-MM-DD HH:mm:ss"
  else if (moment(date_string, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
    date = moment(date_string, "YYYY-MM-DD HH:mm:ss");
  }
  // If the input doesn't match any expected format, throw an error
  else {
    throw new Error("Invalid date format");
  }

  // Format the date into "YYYY-MM-DD HH:mm:ss"
  return date.format("YYYY-MM-DD HH:mm:ss");
}
